import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import type { Article } from '@/shared/typings/types/guide';

export type ArticlesState = Record<string, Article>;

const initialState: ArticlesState = {};

export const articlesSlice = createSlice({
  name: 'articles',
  initialState,
  reducers: {
    setArticle(state, { payload }: PayloadAction<Article>) {
      state[payload.id] = payload;
    },
  },
});

export const { setArticle } = articlesSlice.actions;

export const getArticles = (state: RootState): ArticlesState => state.articles;

export default articlesSlice.reducer;
